import React from 'react';
import Benifits from '../Benifits/Benifits/Benifits';
import WorkTime from '../WorkTime/WorkTime';

const Package = () => {
    return (
        <div>
            <Benifits></Benifits>
            <WorkTime></WorkTime>
        </div>
    );
};

export default Package;